<div [hidden]="!visible" class="wall fs col-12 mb-2 mt-4">
    <div [id]="'scoopit-container-' + idTopic">
        <!--<a href='https://wudo.scoop.it/topic/communaute-industrie-4-0'>[communauté] Industrie 4.0</a>-->
    </div>
</div>
